import get from 'lodash/get';
import { escapeCsvCommands } from '../../utils';

export function prepareExportHeader(allUsers) {
  // eslint-disable-next-line
  let str = `"Appt Type/Fair Name","High School","Appt Date","Appt Time Zone","Appt Start","Appt Finish","Status","Address","City","State","Zip","Contact","Title","Email","Phone","Internal Notes"\r\n`;
  if (allUsers) str = `"Staff Member",${str}`;
  return str;
}

export function prepareCsvFields(event, highschool, address, contact) {
  const chosenVisitLocationType = get(event, 'chosenVisitLocationType');
  const visitUrl = get(event, 'visitUrl');

  let apptTypeFairName;
  let virtualVisitUrl = '';

  if (get(event, 'collegeFairId')) {
    apptTypeFairName ='College Fair';
  } else if (chosenVisitLocationType === 'VIRTUAL') {
    apptTypeFairName ='Virtual Appointment';
    virtualVisitUrl = visitUrl;
  } else {
    apptTypeFairName ='In-Person Appointment';
  }

  const fields = {
    'Staff Member': escapeCsvCommands(get(event, 'staff', '')),
    'Appt Type/Fair Name': escapeCsvCommands(apptTypeFairName),
    'High School': escapeCsvCommands(get(highschool, 'name', '')),
    'Appt Date': escapeCsvCommands(get(event, 'date', '')),
    'Appt Time Zone': escapeCsvCommands(get(address, 'field_hs_elna_timezone', '')),
    'Appt Start': escapeCsvCommands(get(event, 'startISOTime', '')),
    'Appt Finish': escapeCsvCommands(get(event, 'endISOTime', '')),
    'Status': escapeCsvCommands(get(event, 'userBookingStatus', '')),
    'Address': escapeCsvCommands(get(address, 'field_hs_elna_address_line1', '')),
    'City': escapeCsvCommands(get(address, 'field_hs_elna_city', '')),
    'State': escapeCsvCommands(get(address, 'field_hs_elna_state_latest', '')),
    'Zip': escapeCsvCommands(get(address, 'field_hs_eln_zip', '')),
    'Contact': escapeCsvCommands(contact.name),
    'Title': escapeCsvCommands(contact.title),
    'Email': escapeCsvCommands(contact.email),
    'Phone': escapeCsvCommands(contact.phone),
    'Internal Notes': escapeCsvCommands(get(event, 'notes', '')),
    'Virtual Visit URL': escapeCsvCommands(virtualVisitUrl),
  };

  return fields;
}

export function convertToCsv(objArray, allUsers) {
  let str = prepareExportHeader(allUsers);
  for (let i = 0; i < objArray.length; i += 1) {
    let line = '';
    let index;
    const array1 = objArray[i];
    // eslint-disable-next-line
    for (index in array1) {
      /* eslint-disable-next-line */ /* istanbul ignore else */
      if (array1.hasOwnProperty(index)) {
        const value = `${array1[index]}`.replace(/"/g, '""');
        line = `${line}"${value}",`;
      }
    }
    line = line.slice(0, -1);
    str = `${str}${line}\r\n`;
  }
  return str;
}

export function createCsvObjectArray(repVisitsEvents) {
  return repVisitsEvents.map((event) => {
    const highschool = get(event, 'highSchool', null);
    const address = get(highschool, 'address', null);
    const rvAccount = get(event, 'highSchool.repVisitsAccount', null);

    const fairContact = {};
    fairContact.name = get(rvAccount, 'collegeFairsPrimaryContact.name', '');
    fairContact.title = get(rvAccount, 'collegeFairsPrimaryContact.field_job_position', '');
    fairContact.email = get(rvAccount, 'collegeFairsPrimaryContact.field_contact_work', '');
    fairContact.phone = get(rvAccount, 'collegeFairsPrimaryContactPhone', '');

    const primaryContact = {};
    primaryContact.name = get(rvAccount, 'primaryContact.name', '');
    primaryContact.title = get(rvAccount, 'primaryContact.field_job_position', '');
    primaryContact.email = get(rvAccount, 'primaryContact.field_contact_work', '');
    primaryContact.phone = get(rvAccount, 'primaryContactPhone', '');

    const contact = get(event, 'collegeFairId') ? fairContact : primaryContact;

    return prepareCsvFields(event, highschool, address, contact);
  }).reduce((a, b) => a.concat(b), []);
}

export function saveMsBlob(csvEvents, allUsers) {
  if (!window.navigator.msSaveBlob) return;
  const csvData = convertToCsv(csvEvents, allUsers);
  const csvBlob = new Blob([csvData], { type: 'data:text/csv;charset=utf-8,' });
  window.navigator.msSaveBlob(csvBlob, 'RepVisitsEvents.csv');
}
